import { SWMS_SHIFT_PRE_START_CHECKLIST_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const getApiErrorMessage = (error) => {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }

  return error ? Strings.network_error : null;
};

export const getJobShiftPreStartChecklist = ({ jobId, swmsId, shiftId }, abortController = {}) => () => {
  if (!jobId || !swmsId || !shiftId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.get(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/pre-start-checklist`,
    { ...abortController }
  ).then((res) => {
    if (res && res.data && res.data.data) {
      return Promise.resolve(res.data.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    return Promise.reject(getApiErrorMessage(error));
  });
};

export const generateJobShiftPreStartChecklistPdf = ({ jobId, swmsId, shiftId }) => () => {
  if (!jobId || !swmsId || !shiftId) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.post(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/pre-start-checklist/pdf`,
    {}
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    return Promise.reject(getApiErrorMessage(error));
  });
};

export const saveJobShiftPreStartChecklistResponses = ({ jobId, swmsId, shiftId, payload }) => () => {
  if (!jobId || !swmsId || !shiftId || !payload) {
    return Promise.reject(Strings.generic_error);
  }

  return scopeApiInstance.put(
    `${SWMS_SHIFT_PRE_START_CHECKLIST_URL}/${jobId}/shifts/${shiftId}/swms/${swmsId}/pre-start-checklist`,
    payload
  ).then((res) => {
    if (res && res.data) {
      return Promise.resolve(res.data.data || res.data);
    }

    return Promise.reject(Strings.generic_error);
  }).catch((error) => {
    return Promise.reject(getApiErrorMessage(error));
  });
};
